// Finance Department — client wrapper.
// All mutations go through /api/finance/* on the backend. Direct writes
// to kc_giving_records and kc_expense_records are blocked (403).

import { kcFetch, API_BASE, authHeaders } from "../../lib/apiClient";

const H = () => ({ "Content-Type": "application/json", ...authHeaders() });

async function _send(method, path, body) {
  const res = await kcFetch(`${API_BASE}${path}`, {
    method,
    headers: H(),
    body: body === undefined ? undefined : JSON.stringify(body),
  });
  if (!res.ok) {
    let detail = `${method} ${path} failed (${res.status})`;
    try {
      const j = await res.json();
      if (j.detail) {
        // FastAPI returns detail as either a string OR an array of
        // { loc, msg, type } validation errors — flatten the latter.
        if (typeof j.detail === "string") detail = j.detail;
        else if (Array.isArray(j.detail))  detail = j.detail.map(d => d?.msg || JSON.stringify(d)).join("; ");
        else detail = JSON.stringify(j.detail);
      }
    } catch (_) { /* body may not be JSON */ }
    const err = new Error(detail);
    err.status = res.status;
    throw err;
  }
  if (res.status === 204) return null;
  return res.json();
}

// Giving
export const apiListGiving      = (params = {}) => {
  const q = new URLSearchParams(params).toString();
  return _send("GET", `/finance/giving${q ? "?" + q : ""}`);
};
export const apiCreateGiving    = (body)       => _send("POST",   "/finance/giving", body);
export const apiUpdateGiving    = (id, body)   => _send("PUT",    `/finance/giving/${id}`, body);
export const apiVoidGiving      = (id, reason) => _send("POST",   `/finance/giving/${id}/void`, { voidReason: reason });
export const apiVoidApproveGiving = (id)       => _send("POST",   `/finance/giving/${id}/void-approve`);
export const apiVoidRejectGiving  = (id, reason) => _send("POST", `/finance/giving/${id}/void-reject`, { voidReason: reason });
export const apiReassignGiving  = (id, memberId) => _send("POST", `/finance/giving/${id}/reassign`, { memberId });

// Expenses
export const apiListExpenses    = (params = {}) => {
  const q = new URLSearchParams(params).toString();
  return _send("GET", `/finance/expenses${q ? "?" + q : ""}`);
};
export const apiCreateExpense   = (body)       => _send("POST",   "/finance/expenses", body);
export const apiUpdateExpense   = (id, body)   => _send("PUT",    `/finance/expenses/${id}`, body);
export const apiApproveExpense  = (id)         => _send("POST",   `/finance/expenses/${id}/approve`);
export const apiRejectExpense   = (id, reason) => _send("POST",   `/finance/expenses/${id}/reject`, { rejectedReason: reason });
export const apiVoidExpense     = (id, reason) => _send("POST",   `/finance/expenses/${id}/void`, { voidReason: reason });
export const apiVoidApproveExpense = (id)       => _send("POST",   `/finance/expenses/${id}/void-approve`);
export const apiVoidRejectExpense  = (id, reason) => _send("POST", `/finance/expenses/${id}/void-reject`, { voidReason: reason });
export const apiPermanentDeleteGiving  = (id) => _send("DELETE", `/finance/giving/${id}/permanent`);
export const apiPermanentDeleteExpense = (id) => _send("DELETE", `/finance/expenses/${id}/permanent`);

// Aggregate + payees + activity log
export const apiAggregate = (period)    => _send("GET", `/finance/aggregate?period=${encodeURIComponent(period)}`);
export const apiListPayees = ()         => _send("GET", "/finance/payees");
export const apiActivityLog = (params = {}) => {
  const q = new URLSearchParams(params).toString();
  return _send("GET", `/finance/activity-log${q ? "?" + q : ""}`);
};


// Receipts
export const apiGenerateReceipt      = (body) => _send("POST", "/finance/receipts", body);
export const apiGenerateReceiptBatch = (body) => _send("POST", "/finance/receipts/batch", body);
export const apiListReceipts         = (params = {}) => {
  const q = new URLSearchParams(params).toString();
  return _send("GET", `/finance/receipts${q ? "?" + q : ""}`);
};
export const apiReceiptEligibleMembers = (year) => _send("GET", `/finance/receipts/eligible-members?year=${year}`);
